import { render, staticRenderFns } from "./FilterList.vue?vue&type=template&id=a1963bb2&scoped=true&"
import script from "./FilterList.vue?vue&type=script&lang=js&"
export * from "./FilterList.vue?vue&type=script&lang=js&"
import style0 from "./FilterList.vue?vue&type=style&index=0&id=a1963bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1963bb2",
  null
  
)

component.options.__file = "FilterList.vue"
export default component.exports